import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../hooks/useGraphQLMutation.hook';

export const LoginForm_Login_Mutation = graphql(`
  mutation LoginForm_Login($email: EmailAddress!, $password: NonEmptyString!) {
    login(email: $email, password: $password) {
      ...AuthenticationContextProvider_AuthenticatedUser_Fragment
    }
  }
`);

export const useLoginMutation = () =>
  useGraphQLMutation(LoginForm_Login_Mutation);
